import React, { Component } from "react";
import { connect } from "react-redux";
import { postDataAction, getDataAction, deleteDataAction } from "../config/redux/action";
import { Icon, Input, Loader } from "semantic-ui-react";
import { TableComp } from "../component/TableComp";
import { Label, Button, Modal, ModalBody, Badge } from "reactstrap";
import { HeaderComp } from "./Pegawai/HeaderComp";
import { SelectPerusahaan } from "../component/Utils";
import { PG_SELECTED } from "../constants";
import { isBiro } from "../utils/helper";
import LoadingTop from "../component/LoadingTop";

class Pegawai extends Component {
  constructor() {
    super();
    this.state = {
      ValueShowData: 10,
      ValuePage: 0,
      searchName: "",
      typingTimeout: 0,
      modalDelete: false,
      onDelete: false,
      pegawai: {}
    };
  }
  componentDidMount() {
    this.props.filter.perusahaanFilter = null;
    this.getData();
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.filter.perusahaanFilter !== prevProps.filter.perusahaanFilter) {
      this.getData();
    }
  }

  getData = () => {
    this.getDataTable(10, 0);
  };

  handlePagginateTable = (ValueShowData, ValuePage) => {
    this.setState(
      {
        ValueShowData: ValueShowData,
        ValuePage: ValuePage - 1,
      },
      () => {
        this.getDataTable();
      }
    );
  };

  getDataTable = () => {
    let { ValueShowData, ValuePage, searchName } = this.state;
    let search = "";
    if (searchName) {
      search = `
      &search=nama:*${searchName}*,or,
      nik:*${searchName}*,or,
      telepon:*${searchName}*,or,
      perusahaan_nama:*${searchName}*
      `;
    }
    if(this.props.filter.perusahaanFilter) {
      if(this.props.filter.perusahaanFilter !== "all") {
        if(search === "") search = `&search=perusahaan_id:${this.props.filter.perusahaanFilter}`;
        else search += `,and,perusahaan_id:${this.props.filter.perusahaanFilter}`;
      }
    }
    this.props
      .getData({
        path: `pegawai?size=${ValueShowData}&page=${ValuePage}${search}`,
        type: "GET_DATA_TABLE_PEGAWAI",
      })
      .then(() => {});
  };

  handleSearch = (event) => {
    this.setState(
      {
        searchName: event.target.value,
      },
      () => {
        if (this.state.typingTimeout) {
          clearTimeout(this.state.typingTimeout);
        }

        this.setState({
          typingTimeout: setTimeout(() => {
            this.getDataTable();
          }, 100),
        });
      }
    );
  };
  
  handleAction = (d, type) => {
    if(type === "delete") return this.openModalDelete(d);
    else return this.props.history.push(`/pegawai/${type}/${d.id}`)
  }

  openModalDelete = (d) => {
    this.setState({
      modalDelete: true,
      pegawai: d
    });
  }

  deletePegawai = () => {
    const o = {
      path: `pegawai/${this.state.pegawai?.id}`,
      title: "Pegawai",
    };
    this.props.deleteData(o).then(() => {
      this.setState({modalDelete: false});
      this.getData();
    });
  }

  formatterAction = (cell, row) => {
    return (
      <>
       <Icon name="external alternate" color="blue" className="cursor-pointer" onClick={() => this.handleAction(row, "detail")}/>
       {(isBiro() || this.props.user.role == 4 || this.props.user.role == 8) &&
       <>
       <Icon name="pencil" className="cursor-pointer" onClick={() => this.handleAction(row, "edit")} />
       <Icon name="trash alternate outline" color="red" className="cursor-pointer" onClick={() => this.handleAction(row, "delete")} />
       </>
       }
      </>
    )
  }

  render() {
    const columns = [
      {
        dataField: "nik",
        text: "NIK",
      },
      {
        dataField: "nama",
        text: "Nama Pegawai",
        headerStyle: () => ({ width: "20%", textAlign: "left" }),
      },
      {
        dataField: "tingkat",
        text: "Jabatan",
      },
      {
        dataField: "divisi",
        text: "Divisi",
      },
      {
        dataField: "departemen",
        text: "Departemen",
      },
      {
        dataField: "telepon",
        text: "Telepon",
      },
      {
        dataField: "perusahaan.nama",
        text: "Perusahaan",
      },
    ];

    const columnsBiro = [
      ...columns, 
      {
        text: "Aksi",
        formatter: this.formatterAction,
        headerStyle: () => ({ width: "10%" }),
      }
    ]

    return (
      <>
        <HeaderComp />
        <LoadingTop />
        <div className="container-fluid mt-3">
          <div className="row">
            <div className="col-md-12">
              <div className="card container-fluid shadow-sm py-3 border-0">
                <div className="row mb-3">
                  <div className="col-md-6 order-md-1 order-2">
                    <Input
                      onKeyUp={this.handleSearch}
                      icon
                      iconPosition="left"
                      className="w-100 mb-md-0 mb-3"
                      placeholder="Cari Nama Pegawai"
                    >
                      <input />
                      <Icon name="search" />
                    </Input>
                  </div>
                  <div className="col-md-6 order-md-2 order-1 d-flex align-items-center justify-content-md-end mb-md-0 mb-3">
                    {this.props.user.role < 4 && (
                      <>
                        <label className="mr-3">Perusahaan</label>
                        <SelectPerusahaan options={{value: "all", text: "Semua"}} />
                      </>
                    )}
                  </div>
                </div>
                <TableComp
                  data={this.props.dataTable || []}
                  columns={this.props.user.role * 1 > 3 || this.props.user.role * 1 === 1 ? columnsBiro : columns}
                  hover={true}
                  getDataTable={this.handlePagginateTable}
                />
              </div>
            </div>
          </div>
        </div>
        <Modal isOpen={this.state.modalDelete} toggle={() => this.setState({modalDelete: !this.state.modalDelete})}>
          <ModalBody className="text-center my-3">
            <Icon color="red" name="trash alternate outline" size="large" />
            <h3>Delete Pegawai</h3>
            <p>
              Apakah Anda yakin akan menghapus Pegawai{" "}
              <Badge color="success">
                <strong>{this.state.pegawai?.nama}</strong>
              </Badge>
              <br />
              Proses ini tidak dapat diurungkan.
            </p>
            <div>
              <Button
                className="mr-3"
                disabled={this.state.onDelete}
                onClick={() => this.setState({modalDelete: false})}
              >
                Cancel
              </Button>
              <Button
                primary
                disabled={this.state.onDelete}
                color="danger"
                onClick={this.deletePegawai}
              >
                Delete
              </Button>
            </div>
          </ModalBody>
        </Modal>
      </>
    );
  }
}

const reduxState = (state) => {
  return {
    user: state.main.dataUser,
    dataTable: state.pegawaiReducer.dataTable,
    filter: state.main
  };
};

const reduxDispatch = (dispatch) => ({
  postData: (data) => dispatch(postDataAction(data)),
  getData: (data) => dispatch(getDataAction(data)),
  deleteData: (data) => dispatch(deleteDataAction(data))
});

export default connect(reduxState, reduxDispatch)(Pegawai);
